<template>
  <div class="side">
    <div class="qrCode">
      <img :src="gameInfo.qrCode" alt="">
    </div>
    <a class="apple" :href="gameInfo.appStoreDownLoadURL" target="_blank"></a>
    <a class="google" :href="gameInfo.googlePlayDownLoadURL" target="_blank"></a>
    <a class="apk" :href="gameInfo.apkDownLoadURL" target="_blank"></a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'gameInfo'
    ])
  }
}
</script>
